module.exports = __webpack_public_path__ + "img/bebo.d11ec2eb.png";